import { type JSONPromo, type Promo } from '../types/promo.type';

export const promoFromJSON = (jsonPromo: Maybe<JSONPromo>): Maybe<Promo> => {
  if (!jsonPromo) return null;

  return {
    amount: jsonPromo.amount,
    code: jsonPromo.code,
    currency: jsonPromo.currency,
    endDate: jsonPromo.end_date,
    isForNewUser: jsonPromo.is_for_new_user,
    maxAmount: jsonPromo.max_amount,
    maxUses: jsonPromo.max_uses,
    minQualifyAmount: jsonPromo.min_qualify_amount,
    minQualifyUnits: jsonPromo.min_qualify_units,
    offerText: jsonPromo.offer_text,
    percentage: jsonPromo.percentage,
    startDate: jsonPromo.start_date,
    terms: jsonPromo.terms,
    unitType: jsonPromo.unit_type,
    units: jsonPromo.units,
  };
};
